import { useContext as useReactContext } from 'react'
import { ApplicationContext } from 'context/Application'
import { useProfile } from 'context/Profile'
import { useRouteType } from 'context/RouteType'
import { hasOrganizationContext } from 'hooks/permission/usePermission'

export function useContext({ isMutation } = {}) {
  const { isAuthenticated, isGlobalRole } = useProfile()
  const { isOrganizationContextRoute } = useRouteType()
  const { organization: organizationId } = useReactContext(ApplicationContext)

  return {
    organizationId: hasOrganizationContext({
      isAuthenticated,
      isGlobalRole,
      isOrganizationContextRoute,
      isRead: !isMutation,
    })
      ? organizationId
      : undefined,
  }
}
